export { amSynth } from './amSynth';
export { casio01 } from './casio01';
export { fmSynth } from './fmSynth';
export { monoSynth } from './monoSynth';
export { moog01 } from './moog01';
export { piano01 } from './piano01';
export { pluckSynth } from './pluckSynth';
export { stylophone01 } from './stylophone01';
export { synth01 } from './synth01';

export const instruments = [
    { name: "", slug: "" },
    { name: "Synth 01", slug: "synth01", type: 'synth' },
    { name: "MonoSynth", slug: "monoSynth", type: 'monoSynth' },
    { name: "AMSynth", slug: "amSynth", type: 'amSynth' },
    { name: "FMSynth", slug: "fmSynth", type: 'fmSynth' },
    { name: "PluckSynth", slug: "pluckSynth", type: 'pluckSynth' },
    { name: "Piano 01", slug: "piano01", type: 'piano' },
    { name: "Moog 01", slug: "moog01", type: 'moog01' },
    { name: "Stylophone 01", slug: "stylophone01", type: 'stylophone01' },
    { name: "Casio 01", slug: "casio01", type: 'casio01' }
]